import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { doPolygonsSort } from 'redux/actions';

import PolygonCreationSection from './PolygonCreationSection/PolygonCreationSection';
import ImportPolygonSection from './ImportPolygonSection/ImportPolygonSection';
import PolygonContentSection from './PolygonContentSection/PolygonContentSection';
import MapView from './MapView/MapView';
import PolygonSearchSection from './PolygonSearchSection/PolygonSearchSection';

import { IconLoader } from '../../../common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import {
  calculateListHeight,
  calculateListItemsHeight,
  useGetComponentHeight
} from './functions';
import {
  DEFAULT_LIST_STYLE
} from './constants';
import './MapControlPopUp.css';

const MapControlPopUp = (props) => {
  const {
    tileProviderName,
    changeTileProvider,
    selectedDrawingShape,
    changeDrawingShape,
    handlerShowPolygonOptionsModal,
    isAllowPolygonActivity,
    screenSize: { height },
    searchPolygonsText,
    setSearchPolygonsText,
    importPolygon,
    exportPolygon,
    toggleDeleteConfirmationModal,
    setMapActivatedPolygonMode
  } = props;

  const polygonList = useSelector((store) => store.ui.devicesPage.polygons);
  const mapSize = useSelector((store) => store.style.mapSize);
  const dispatch = useDispatch();

  const mapControlPopUpRef = useRef();
  const currentListHeightRef = useRef();
  const polygonContentSectionRefs = useRef({ mapControlPopUpRef, currentListHeightRef });

  const componentHeight = useGetComponentHeight(mapControlPopUpRef, currentListHeightRef);
  const [listStyle, setListStyle] = useState(DEFAULT_LIST_STYLE);
  const [filteredPolygonList, setFilteredPolygonList] = useState(polygonList);
  const [searchSectionWrapperColor, setSearchSectionWrapperColor] = useState('#f2f2f2');
  const [isAllowMapPopUpActivity, setIsAllowMapPopUpActivity] = useState(true);

  useEffect(() => {
    if (searchPolygonsText.trim() === '') {
      setFilteredPolygonList(polygonList);
      return;
    }

    const filteredList = polygonList.filter(polygon => polygon.properties.name.toLowerCase().includes(searchPolygonsText.toLowerCase()));
    setFilteredPolygonList(filteredList);
  }, [polygonList, searchPolygonsText]);

  useEffect(() => {
    if (mapSize === 'shrink') {
      setListStyle(DEFAULT_LIST_STYLE);
    } else {
      const listHeight = calculateListHeight(height, componentHeight);
      const listItemsHeight = calculateListItemsHeight(listHeight);
      setListStyle({ maxHeight: listItemsHeight + 'px' });
    }
  }, [height, componentHeight, mapSize]);

  const searchPolygonsBorderColor = (color) => {
    setSearchSectionWrapperColor(color);
  };

  const setPolygonsSorting = (polygonIds) => {
    dispatch(doPolygonsSort(polygonIds));
  };

  return (
    <section
      className='MapControlPopUp'
      ref={mapControlPopUpRef}
    >
      <div className='MapControlPopUp_Header'>
        <div
          className='MapControlPopUp_Header_Gnb border'
          onClick={props.stopPolygonEditingShape}
        >
          <SvgAF
            img={IconLoader.icon_gnb_off}
            hover={IconLoader.icon_gnb_off_hover}
          />
        </div>

        <div className='MapControlPopUp_Header_Creation_Section_Wrapper border'>
          <PolygonCreationSection
            stopPolygonEditingShape={props.stopPolygonEditingShape}
            selectedDrawingShape={selectedDrawingShape}
            changeDrawingShape={changeDrawingShape}
          />
        </div>

        <div
          className='MapControlPopUp_Header_Upload_Section_Wrapper border'
          onClick={props.stopPolygonEditingShape}
        >
          <ImportPolygonSection importPolygon={importPolygon} />
        </div>

        <div
          className='MapControlPopUp_Header_Search_Section_Wrapper border'
          style={{ borderColor: searchSectionWrapperColor }}
          onClick={props.stopPolygonEditingShape}
        >
          <PolygonSearchSection
            searchPolygonsText={searchPolygonsText}
            searchPolygons={setSearchPolygonsText}
            searchPolygonsBorderColor={searchPolygonsBorderColor}
          />
        </div>
      </div>

      <div className='MapControlPopUp_Horizontal_Line' />

      <PolygonContentSection
        polygonList={filteredPolygonList}
        ref={polygonContentSectionRefs}
        listStyle={listStyle}
        handlerShowPolygonOptionsModal={handlerShowPolygonOptionsModal}
        isAllowPolygonActivity={isAllowPolygonActivity}
        isScrollAble={isAllowMapPopUpActivity}
        allowMapPopUpActivityAction={(value) => setIsAllowMapPopUpActivity(value)}
        toggleDeleteConfirmationModal={toggleDeleteConfirmationModal}
        exportPolygon={exportPolygon}
        setPolygonsSorting={setPolygonsSorting}
        setMapActivatedPolygonMode={setMapActivatedPolygonMode}
        stopPolygonEditingShape={props.stopPolygonEditingShape}
      />

      <div className='MapControlPopUp_Horizontal_Line Bottom' />

      <MapView
        stopPolygonEditingShape={props.stopPolygonEditingShape}
        changeTileProvider={changeTileProvider}
        tileProviderName={tileProviderName}
      />
    </section>
  );
};

export default MapControlPopUp;